import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { DangerAlert } from '@shared/alert';
import * as HttpStatus from 'http-status-codes';
import { Observable, throwError } from 'rxjs';
import { catchError, first, switchMap, take, map } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private store: Store<{}>) {}

  intercept(request: HttpRequest<{}>, next: HttpHandler): Observable<HttpEvent<{}>> {
    return this.auth.isAuthenticated$.pipe(
      first(),
      switchMap((isAuthenticated) =>
        this.auth.getAccessToken().pipe(
          take(1),
          map((token) => ({ isAuthenticated, token })),
        ),
      ),
      switchMap(({ isAuthenticated, token }) => {
        if (isAuthenticated && !request.params.has('bearer')) {
          request = request.clone({ headers: this.buildHeaders(request, token) });
        }
        return next
          .handle(request)
          .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
      }),
    );
  }

  private buildHeaders(request: HttpRequest<{}>, token) {
    const contentType = request.headers.get('Content-Type');

    let headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    if (!!contentType) {
      headers = headers.append('Content-Type', contentType);
    }
    return headers;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === HttpStatus.FORBIDDEN) {
      this.store.dispatch(new DangerAlert(`Access denied`));
    }
    if (error.status === HttpStatus.UNAUTHORIZED || error.status === 0) {
      this.auth.logout(false);
    }
    return throwError(error);
  }
}
